<div class="panel-group" *ngIf="full && !forDocuments">
    <div class="panel" [class.panel-info]="equipment.Active" [class.panel-warning]="!equipment.Active"  cdkDrag [cdkDragData]="equipment">
        <div [class.panel-heading]="(equipment.Status==0 || equipment.Status==5 || equipment.Status==6 || live)" [class.panel-Staged1]="(equipment.Status==1 || equipment.Status==2 || equipment.Status==7)" [class.panel-warning1]="equipment.Status==4">
            <h5 style="display: inline-block">
                <span [style.color]="(equipment.Status==0 || equipment.Status==5 || equipment.Status==6 || live)? 'black':'white'">{{ equipment.Serial }} ({{ model.Name }} {{ poweredby.Name }})</span>
            </h5>
            <div class="pull-right btn-toolbar" role="toolbar">
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn btn-info" title="Equipment Details" (click)="details()">
                        <i data-toggle="tooltip" class="fa fa-list-alt fa-lg"></i>
                    </button>
                </div>
                <div class="btn-group btn-group-sm" *ngIf="!live">
                    <button type="button" class="btn btn-info" title="Edit Equipment" (click)="edit()">
                        <i data-toggle="tooltip" class="fa fa-edit fa-lg"></i>
                    </button>
                    <button type="button" class="btn btn-info" title="Remove Equipment" (click)="delete()">
                        <i data-toggle="tooltip" class="fa fa-lg fa-trash-o"></i>
                    </button>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</div>
<ng-container *ngIf="simplified">
    <div class="list-group-item" [class.info]="(equipment.Status==0 || equipment.Status==1 || live)" [class.panel-warning1]="(equipment.Status==4 || equipment.Status==6)" [class.panel-Staged1]="(equipment.Status==5 || equipment.Status==7 || equipment.Status==2)">
        <span>
          {{equipment.Serial}} ({{equipment.Model.Name}} {{equipment.PoweredBy.Name}})
        </span>
        <div class="pull-right btn-group btn-group-xs" *ngIf="!live && equipment.Status!=4 && equipment.Status!=6">
            <button type="button" class="btn btn-info" title="Remove Equipment" (click)="removeAssociation()">
                <span class="fa fa-minus fa-lg"></span>
            </button>
        </div>
    </div>
</ng-container>




<div class="panel-group" *ngIf="forDocuments">
    <div class="panel" [class.panel-info]="equipment.Active" [class.panel-warning]="!equipment.Active">
        <div class="panel-heading" data-toggle="tooltip">
            <h5 style="display: inline-block;">
                <span class="badge">
                    {{
                        equipment.DocumentCount
                    }}
                </span>
                {{ equipment.Serial }} ({{ model.Name }} {{ poweredby.Name }})
            </h5>
            <div class="pull-right btn-toolbar" role="toolbar">
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn btn-info" title="Show Assigned Documents" (click)="getDocuments()">
                        <span data-toggle="tooltip" class="fa fa-lg" [class.fa-chevron-down]="!documentsShown" [class.fa-chevron-up]="documentsShown"></span>
                    </button>
                    <button type="button" class="btn btn-info" title="Edit Document Assignments" (click)="showRecommended()">
                        <span data-toggle="tooltip" class="fa fa-lg fa-edit"></span>
                    </button>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="panel-collapse collapse" [class.in]="documentsShown">
            <div class="panel-body" [attr.data-equipment-id]="equipment.Equipment_ID">
                <div *ngIf="processing" class="cdk-droplist-group" style="overflow-y:scroll; max-height: 600px;">
                    <i class="fa fa-spinner fa-spin"></i> Loading Documents...
                </div>
                <div *ngIf="!processing" class="list-group" cdkDropList [cdkDropListData]="documents" (cdkDropListDropped)="transferDataSuccess($event)" style="overflow-y: scroll; min-height: 100px; max-height: 600px;">
                  <div class="list-group-item" *ngFor="let document of documents" cdkDrag [cdkDragDisabled]="true">
                        <div class="panel-group">
                            <div class="panel">
                                <div class="panel-heading" style="padding: 0 0 0 5px;">
                                    <h5 style="display: inline-block">
                                        {{ document.ProductName }}
                                        <br />
                                        {{ document.FileName }}
                                    </h5>
                                    <!--<span *ngIf="document.Publishing" class="text-success fa fa-check-circle" title="Publishing"></span>
                                    <span *ngIf="!document.Publishing" class="text-danger fa fa-warning" title="Not Publishing"></span>-->
                                    <div class="pull-right btn-toolbar" role="toolbar" style="margin-left:3px; margin-top:7px;" *ngIf="!live  || isDocumentPage">
                                        <div class="btn-group btn-group-xs">
                                            <button class="btn btn-info" (click)="removeDocument(document.Id)">
                                                <span class="fa fa-minus"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div bsModal #DeleteEquipment="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Delete Equipment
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Delete this equipment:
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="DeleteSelectedEquipment()">Confirm Delete</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>